import React from 'react'
import PropTypes from 'prop-types'
import './_styles.scss'
import Utils from '../../../../../utils/Utils'
import Asset from '../../../../../requests/apa/Asset'

const CardTop3 = ({ rank, featured, player }) => {
  const featuredClass = featured ? ' estadisticas-card-top--featured' : ''

  return (
    <div className={`estadisticas-card-top${featuredClass}`}>
      <div className='estadisticas-card-top__media'>
        <img
          className='estadisticas-card-top__image'
          src={player.player.image ? player.player.image : Asset.get('eventodeportivo_placeholder_imagen_jugador_7')}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = Asset.get('eventodeportivo_placeholder_imagen_jugador_7');
          }}
        />
        <div className='estadisticas-card-top__gradient' />

        <div className='estadisticas-card-top__info'>
          <p className='estadisticas-card-top__player'>{Utils.cutPlayerString(player.player.name, 21)}</p>
          <p className='estadisticas-card-top__score'>{Utils.cutPlayerString(player.player.value ? player.player.value : '0000', 4)}</p>
          <div className='estadisticas-card-top__country-row'>
            <span className='estadisticas-card-top__country'>{Utils.cutPlayerString(player.player.country.name, 15)}</span>
            <img
              className='estadisticas-card-top__flag'
              src={player.player.country.flag ? player.player.country.flag : Asset.get('eventodeportivo_placeholder_imagen_bandera_1')}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Asset.get('eventodeportivo_placeholder_imagen_bandera_1');
              }}
            />
          </div>
        </div>
      </div>

      <div className='estadisticas-card-top__rank'>
        <span className='estadisticas-card-top__rank-number'>{player.position}</span>
      </div>
    </div>
  )
}

CardTop3.propTypes = {
  featured: PropTypes.bool,
}

CardTop3.defaultProps = {
  featured: false,
}

export default CardTop3



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/EstadisticasJuegos/Components/CardTop3/index.jsx